// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"277":"4d9cf522","686":"2d3250e7","723":"3f1cbaae","895":"e77d94f3","902":"d1f1d631"}[chunkId] + ".chunk.js";
};